import { IQuantity, Quantity } from "../../../common/models/quantity.model";
import { translateDictionaryName } from "../../../cancellationReasons/actions/dictionaryNames";

interface IActions {
  openPanel: () => void;
  delete: () => void;
  addReason: (e: any) => void
}

export const generateItems = (
  quantity: IQuantity,
  actions: IActions,
  reasons: Array<any>,
  t: any,
) => {
  switch (quantity) {
    case Quantity.NONE:
      const itemsArr = reasons.map(({ id, name }) => {
        let icon = { iconProps: {} };

        if (name === 'Deaktywacji klienta') {
          icon = { iconProps: { iconName: "userRemove" } };
        } else {
          icon = { iconProps: { iconName: "UnstackSelected" } };
        }

        return {
          key: id,
          id: id,
          text: translateDictionaryName(name, t),
          iconProps: icon.iconProps,
          onClick: actions.addReason,
        };
      });

      return [
        {
          key: "add",
          text: t('cancellationReasons.commands.addReason'),
          iconProps: { iconName: "add" },
          subMenuProps: {
            items: [...itemsArr],
          },
        },
      ];
    case Quantity.ONE:
      return [
        {
          key: "edit",
          text: t('cancellationReasons.commands.edit'),
          iconProps: { iconName: "edit" },
          name: "edit",
          onClick: actions.openPanel,
        },
        {
          key: "delete",
          text: t('cancellationReasons.commands.delete'),
          iconProps: { iconName: "delete" },
          name: "delete",
          onClick: actions.delete,
        },
      ];
    default:
      return [];
  }
};
